/**
 * Sequences.tsx - Central registry of all experiment sequences
 * Last updated: 2025-08-12 14:23:30
 * Updated by: JulianPolly
 */

import { ScreenProps } from "../SequenceController";

import {
    M1SequenceKey,
    useM1Sequence
} from "./Infoscreens/M1Sequence";


import {
    AttributeFramingKey,
    useAttributeFramingSequence
} from "./AttributeFramingSequence/AttributeFramingSequence";

import {
    MentalAccountingKey,
    useMentalAccountingSequence
} from "./MentalAccountingSequence/MentalAccountingSequence";

import {
    RiskyChoiceFramingKey,
    useRiskyChoiceFramingSequence
} from "./RiskyChoiceFramingSequence/RiskyChoiceFramingSequence";

import {
    PretestKey,
    PretestSequence
} from "./PretestSequence/PretestSequence";

import { PosttestKey, PosttestSequence } from "./PosttestSequence/PosttestSequence";
import { LGFramingKey, useLGFramingSequence } from "./LGFramingSequence/LGFramingSequence";

import {
    UltimatumKey,
    useUltimatumSequence
} from "./UltimatumSequence/UltimatumSequence";

import {
    DecoyEffectKey,
    useDecoyEffectSequence
} from "./DecoyEffectSequence/DecoyEffectSequence";

import {
    CrossoverDefaultKey,
    useCrossoverDefaultSequence
} from "./DefaultOptionSequence/DefaultOptionSequence";

import {
    BandwagonEffectKey,
    useBandwagonSequence
} from "./BandwagonSequence/BandwagonSequence";

import {
    NudgingKey,
    useNudgingSequence
} from "./NudgingSequence/NudgingSequence";

import {
    EndowmentEffectKey,
    useEndowmentEffectSequence
} from "./EndowmentEffectSequence/EndowmentEffectSequence";

export type ScreenConfig = {
    component: React.FC<ScreenProps>,
    defaultResult?: object;
    canContinueDefault?: boolean;
}

export type ScreenSequence = {
    name: string;
    description: string;
    screens: ScreenConfig[];
    resultScreenIndex?: number;
    explanationScreenIndex?: number;
    group?: string;
}


// all available sequences in the web app
export const Sequences: { [key: string]: () => ScreenSequence } = {
    [PretestKey]: () => PretestSequence,
    [MentalAccountingKey]: useMentalAccountingSequence,
    [AttributeFramingKey]: useAttributeFramingSequence,
    [LGFramingKey]: useLGFramingSequence,
    [RiskyChoiceFramingKey]: useRiskyChoiceFramingSequence,
    [UltimatumKey]: useUltimatumSequence,
    [EndowmentEffectKey]: useEndowmentEffectSequence,
    [PosttestKey]: () => PosttestSequence,
    [M1SequenceKey]: useM1Sequence,
    [DecoyEffectKey]: useDecoyEffectSequence,
    [CrossoverDefaultKey]: useCrossoverDefaultSequence,
    [BandwagonEffectKey]: useBandwagonSequence,
    [NudgingKey]: useNudgingSequence,

};